import React from 'react';
import { Building2, Palette, Users, Briefcase, ArrowRight } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import { audienceSection } from '../content/landingContent';

const iconMap = {
  0: Building2,
  1: Palette,
  2: Users,
  3: Briefcase
};

export const AudienceSection = () => {
  return (
    <section id="who-its-for" className="py-24 lg:py-32 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="text-center mb-20">
            <h2 className="text-2xl lg:text-3xl font-bold text-stone-900 mb-6 tracking-tight">
              {audienceSection.headline}
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              {audienceSection.subheadline}
            </p>
          </div>
        </AnimateOnScroll>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {audienceSection.audiences.map((audience, index) => {
            const Icon = iconMap[index];
            return (
              <AnimateOnScroll key={index} delay={index * 100}>
                <div 
                  className="card-hover text-left space-y-5 p-8 rounded-xl bg-white hover:shadow-2xl transition-all duration-300 group border-2 border-stone-200 hover:border-slate-400 relative overflow-hidden"
                >
                  {/* Left accent border on hover */}
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-slate-600 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-slate-100 to-slate-200 group-hover:from-slate-600 group-hover:to-slate-700 transition-all duration-300 flex items-center justify-center shadow-sm">
                      <Icon className="w-7 h-7 text-slate-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-2xl font-bold text-stone-900 group-hover:text-slate-700 transition-colors">
                      {audience.title}
                    </h3>
                  </div>
                  
                  <p className="text-stone-600 leading-relaxed text-base pl-0">
                    {audience.description}
                  </p>
                  
                  {/* Arrow indicator */}
                  <div className="flex items-center text-slate-600 group-hover:text-slate-700 transition-colors pt-2">
                    <ArrowRight className="w-5 h-5 transform group-hover:translate-x-2 transition-transform duration-300" />
                  </div>
                </div>
              </AnimateOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;